import _objectSpread from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toPropertyKey from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js";
import { LeafletProvider, addClassName, useLeafletContext } from '@react-leaflet/core';
import React, { forwardRef, useState, useEffect, useImperativeHandle, useMemo } from 'react';
import { createPortal } from 'react-dom';
var DEFAULT_PANES = ['mapPane', 'markerPane', 'overlayPane', 'popupPane', 'shadowPane', 'tilePane', 'tooltipPane'];
function omitPane(obj, pane) {
  var _p = obj[pane],
    others = _objectWithoutProperties(obj, [pane].map(_toPropertyKey));
  return others;
}
function createPane(name, props, context) {
  var _props$pane;
  if (DEFAULT_PANES.indexOf(name) !== -1) {
    throw new Error("You must use a unique name for a pane that is not a default Leaflet pane: ".concat(name));
  }
  if (context.map.getPane(name) != null) {
    throw new Error("A pane with this name already exists: ".concat(name));
  }
  var parentPaneName = (_props$pane = props.pane) !== null && _props$pane !== void 0 ? _props$pane : context.pane;
  var parentPane = parentPaneName ? context.map.getPane(parentPaneName) : undefined;
  var element = context.map.createPane(name, parentPane);
  if (props.className != null) {
    addClassName(element, props.className);
  }
  if (props.style != null) {
    Object.keys(props.style).forEach(function (key) {
      // @ts-ignore
      element.style[key] = props.style[key];
    });
  }
  return element;
}
function PaneComponent(props, forwardedRef) {
  var _useState = useState(props.name),
    _useState2 = _slicedToArray(_useState, 1),
    paneName = _useState2[0];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    paneElement = _useState4[0],
    setPaneElement = _useState4[1];
  useImperativeHandle(forwardedRef, function () {
    return paneElement;
  }, [paneElement]);
  var context = useLeafletContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var newContext = useMemo(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      pane: paneName
    });
  }, [context]);
  useEffect(function () {
    setPaneElement(createPane(paneName, props, context));
    return function removeCreatedPane() {
      var _pane$remove;
      var pane = context.map.getPane(paneName);
      pane === null || pane === void 0 || (_pane$remove = pane.remove) === null || _pane$remove === void 0 || _pane$remove.call(pane);
      // @ts-ignore map internals
      if (context.map._panes != null) {
        // @ts-ignore map internals
        context.map._panes = omitPane(context.map._panes, paneName);
        // @ts-ignore map internals
        context.map._paneRenderers = omitPane(
        // @ts-ignore map internals
        context.map._paneRenderers, paneName);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return props.children != null && paneElement != null ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(LeafletProvider, {
    value: newContext
  }, props.children), paneElement) : null;
}
export var Pane = /*#__PURE__*/forwardRef(PaneComponent);